/* eslint-disable */
// ============================================================
//  native-push.js — Push NATIF (Firebase FCM) via Capacitor.
//
//  L'app Android/iOS Capacitor charge le site live (server.url).
//  Ce code s'exécute alors DANS l'app native : il récupère le
//  jeton FCM de l'appareil (pont Capacitor) et l'enregistre dans
//  la table `fcm_tokens` (lié à l'utilisateur connecté). Le serveur
//  (Edge Function `send-fcm`) envoie ensuite les push à ces jetons.
//
//  ⚠️ Sur le WEB normal (navigateur), `window.Capacitor` n'existe
//  pas → toutes les fonctions sont des NO-OP. Zéro impact sur le site.
//  On accède au plugin via le pont injecté (window.Capacitor.Plugins)
//  → pas besoin d'ajouter @capacitor/* au bundle web.
// ============================================================
import { supabase } from "./supabase";

let started = false;

function getCap() {
  if (typeof window === "undefined") return null;
  const Cap = window.Capacitor;
  if (!Cap || typeof Cap.isNativePlatform !== "function" || !Cap.isNativePlatform()) return null;
  return Cap;
}

async function upsertToken(fcmToken, platform) {
  try {
    if (!fcmToken) return;
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return; // pas connecté -> on enregistrera au prochain login
    await supabase.from("fcm_tokens").upsert(
      {
        user_id: user.id,
        token: fcmToken,
        platform: platform || "android",
        user_agent: (navigator.userAgent || "").slice(0, 250),
      },
      { onConflict: "token" }
    );
  } catch (e) { /* silencieux */ }
}

// À appeler quand l'utilisateur est connecté (App.jsx). Idempotent :
// installe les listeners une seule fois, mais re-register à chaque appel
// pour ré-associer le jeton au bon utilisateur.
export async function initNativePush() {
  const Cap = getCap();
  if (!Cap) return; // web -> no-op
  const PN = Cap.Plugins && Cap.Plugins.PushNotifications;
  if (!PN) return;
  const platform = (typeof Cap.getPlatform === "function") ? Cap.getPlatform() : "android";

  if (started) {
    // Déjà initialisé : re-register pour ré-émettre le jeton (nouveau user).
    try { await PN.register(); } catch (e) {}
    return;
  }
  started = true;

  try {
    PN.addListener("registration", (token) => {
      upsertToken(token && token.value, platform);
    });
    PN.addListener("registrationError", () => {});
    // Clic sur la notif système -> deep link (?ad= / ?trip= / chat…).
    PN.addListener("pushNotificationActionPerformed", (action) => {
      try {
        const url = action && action.notification && action.notification.data && action.notification.data.url;
        if (url && url !== "/") window.location.href = url;
      } catch (e) {}
    });

    let perm = await PN.checkPermissions();
    if (perm && perm.receive !== "granted") perm = await PN.requestPermissions();
    if (perm && perm.receive === "granted") {
      await PN.register();
    }
  } catch (e) { /* silencieux */ }
}
